import type { JSX } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { ModalDialog } from 'core-components/library/modalDialog'

import { sobActualsModalTranslation } from '../../../translation'

import styles from './SobActualsIncompletePrompt.module.scss'

type SobActualsIncompletePromptContentProps = {
  onReturnToFilling: () => void
  onSaveAsIs: () => void
  isSaving: boolean
}

type SobActualsIncompletePromptProps = SobActualsIncompletePromptContentProps & {
  show: boolean
}

const SobActualsIncompletePromptContent = ({
  onReturnToFilling,
  onSaveAsIs,
  isSaving,
}: SobActualsIncompletePromptContentProps): JSX.Element => (
  <div className={styles.content}>
    <p className={styles.text}>
      <Translation text={sobActualsModalTranslation.incompleteWarning} span />
    </p>
    <div className={styles.actions}>
      <Button
        className={styles.actionButton}
        color="danger"
        variant="text"
        size="sm"
        disabled={isSaving}
        onClick={onReturnToFilling}
      >
        <Translation text={sobActualsModalTranslation.returnToFilling} span />
      </Button>
      <Button
        className={styles.actionButton}
        color="primary"
        size="sm"
        loading={isSaving}
        onClick={onSaveAsIs}
      >
        <Translation text={sobActualsModalTranslation.saveAsIs} span />
      </Button>
    </div>
  </div>
)

export const SobActualsIncompletePrompt = ({
  show,
  onReturnToFilling,
  onSaveAsIs,
  isSaving,
}: SobActualsIncompletePromptProps): JSX.Element => (
  <ModalDialog<SobActualsIncompletePromptContentProps>
    show={show}
    size="sm"
    classes={{ window: styles.window }}
    header={() => (
      <div className={styles.title}>
        <Translation text={sobActualsModalTranslation.incompleteWarningTitle} span />
      </div>
    )}
    content={SobActualsIncompletePromptContent}
    contentProps={{
      onReturnToFilling,
      onSaveAsIs,
      isSaving,
    }}
    onClose={onReturnToFilling}
  />
)
